import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { ErrorHandlingService } from '../../services/error-handling/error-handling.service';
import { SpinnerService } from '../../services/spinner/spinner.service';
import { HttpHeaderConstants } from '../../services/http-header.constant';
import { environment } from '../../environments/environment';
import { FormulaType } from '../../models/shared-email/email-manager-action.data.model';

@Injectable({
    providedIn: 'root',
})
export class FormulaValidationService {
    readonly #http = inject(HttpClient);
    readonly #errorHandlingService = inject(ErrorHandlingService);
    readonly #spinnerService = inject(SpinnerService);

    private FORMULA_VALIDATION_URL = environment.publicApiHost + '/appcloud/formulas/validate';

    validateFormula(
        formula: string,
        formulaType: FormulaType,
        additionalHeaders: any = {}
    ): Observable<FormulaValidationResponse> {
        this.#spinnerService.addProcess('FormulaValidationService.validateFormula', 'Validating your formula...');
        const httpOptions = {
            headers: new HttpHeaders({ ...HttpHeaderConstants.defaultHeaders, ...additionalHeaders }),
            params: new HttpParams().set('formulaType', formulaType),
        };
        return this.#http.post<FormulaValidationResponse>(this.FORMULA_VALIDATION_URL, formula, httpOptions).pipe(
            catchError(error => {
                this.#errorHandlingService.handleHttpError(
                    error,
                    false,
                    'An error occurred while attempting to validate your formula. Please try again later.'
                );
                return of<FormulaValidationResponse>();
            }),
            finalize(() => this.#spinnerService.completeProcess('FormulaValidationService.validateFormula'))
        );
    }
}

export interface FormulaValidationResponse {
    valid: boolean;
    message: string;
}
